import React from "react";
import { useParams } from "react-router-dom";

const UserDetails = () => {
  const { userId } = useParams();

  return (
    <div>
      <h1>Detalhes do Usuário</h1>
      <p>ID do Usuário: {userId}</p>
      {/* Renderize mais informações aqui */}
    </div>
  );
};

export default UserDetails;
